import { Stack } from "@fluentui/react";
import React, { FC } from "react";
import Moment from "react-moment";
import { DailyReport } from "../../models";
import SofIcon from "../common/Icons";
import "./Reports.css";

type Props = {
  dailyReport: DailyReport;
  reportType: string;
  includeComments: boolean;
};

const PrintPage: FC<Props> = (props: Props) => {
  const summaryNominationCount =
    props.dailyReport.longDockLogReport.nominations.filter(
      (n) => n.isSelected
    ).length;
  const detailsNominationCount = props.dailyReport.nominations.filter(
    (n) => n.isSelected
  ).length;
  const lastDetailsRecord = props.dailyReport.nominations
    .filter((n) => n.isSelected)
    .slice(-1)[0];

  return (
    <>
      {props.reportType == "Summary" && (
        <table>
          <thead>
            <Stack tokens={{ childrenGap: 20 }} horizontal>
              <div
                style={{
                  borderRight: "0.5px solid #E2E6E8",
                  paddingRight: "20px",
                  marginBottom: "25px",
                }}
              >
                <img
                  src="/logo-yellow.svg"
                  style={{ width: 80.25, height: 48 }}
                />
              </div>
              <div
                style={{
                  paddingRight: "15px",
                  paddingLeft: "5px",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Statement of Facts Summary Reports
                </div>
                <div>QADWorks Technical Solutions Inc</div>
              </div>
            </Stack>
          </thead>

          <tbody>
            <div>
              <div>
                <div
                  style={{
                    backgroundColor: "black",
                    height: "40px",
                    paddingTop: "5px",
                    paddingLeft: "15px",
                    color: "white",
                  }}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {props.dailyReport.vehicleName}
                  </span>

                  <Stack
                    tokens={{ childrenGap: 12 }}
                    horizontal
                    style={{ float: "right" }}
                  >
                    <div
                      style={{
                        borderRight: "0.5px solid #FFFFFF",
                        paddingRight: "15px",
                      }}
                    >
                      Line Handling #:{" "}
                      <strong>
                        {`${props.dailyReport.lineHandlingNo.substr(
                          props.dailyReport.lineHandlingNo.length - 6
                        )}`}
                      </strong>
                    </div>
                    <div
                      style={{
                        borderRight: "0.5px solid #FFFFFF",
                        paddingRight: "15px",
                        paddingLeft: "5px",
                      }}
                    >
                      Dock #:{" "}
                      <strong>
                        {props.dailyReport.longDockLogReport.dockNumber}
                      </strong>
                    </div>
                    <div
                      style={{
                        paddingRight: "15px",
                        paddingLeft: "5px",
                      }}
                    >
                      Departed:{" "}
                      <strong>
                        {
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.vesselSailed} UTC`}</Moment>
                        }
                      </strong>
                    </div>
                  </Stack>
                </div>

                <table className="tbl-report">
                  <tr>
                    <td>{"Arrived Along Side: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport
                          .arrivedAlongSide && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.arrivedAlongSide} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                    <td>{"First Hose On: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport.firstHoseOn && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.firstHoseOn} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>{"Gangway On Vessel: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport
                          .gangwayOnVessel && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.gangwayOnVessel} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                    <td>{"Last Hose Off: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport.lastHoseOff && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.lastHoseOff} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>{"Pre-transfer Conf. Start: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport
                          .preTransferConferenceStart && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.preTransferConferenceStart} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                    <td>{"Vessel Sailed: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport.vesselSailed && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.vesselSailed} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>{"Pre-transfer Conf. Finish: "}</td>
                    <td>
                      <strong>
                        {props.dailyReport.longDockLogReport
                          .preTransferConferenceFinish && (
                          <Moment
                            format="ll HH:mm"
                            local
                          >{`${props.dailyReport.longDockLogReport.preTransferConferenceFinish} UTC`}</Moment>
                        )}{" "}
                      </strong>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
              </div>

              {summaryNominationCount > 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    width: "100%",
                    border: "1px solid #E2E6E8",
                  }}
                >
                  <table className="tbl-report">
                    <tr className="report-header-blue">
                      <td>Line #</td>
                      <td>Tank</td>
                      <td>Customer</td>
                      <td>Product</td>
                      <td>Vessel Tank#</td>
                      <td>Quantity/MT</td>
                    </tr>
                    {props.dailyReport.longDockLogReport.nominations.map(
                      (nomination) => (
                        <>
                          {nomination.isSelected && (
                            <>
                              <tr
                                style={{
                                  background: "#F2F4F6",
                                }}
                              >
                                <td>{nomination.ourLineNumber}</td>
                                <td>{nomination.tank}</td>
                                <td>{nomination.customer}</td>
                                <td>{nomination.product}</td>
                                <td>{nomination.vesselTankNumber}</td>
                                <td>{nomination.quantity}</td>
                              </tr>
                              <tr>
                                <td colSpan={6} style={{ padding: "0" }}>
                                  <table className="tbl-report">
                                    <tr>
                                      <td>{"Vapor Hose Connected: "}</td>
                                      <td>
                                        <strong>
                                          {nomination.vaporHoseConnected && (
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.vaporHoseConnected} UTC`}</Moment>
                                          )}
                                        </strong>
                                      </td>
                                      <td>{"Vapor Hose Disconnected: "}</td>
                                      <td>
                                        <strong>
                                          {nomination.vaporHoseDisconnected && (
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.vaporHoseDisconnected} UTC`}</Moment>
                                          )}
                                        </strong>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>{"Cargo Hose Connected: "}</td>
                                      <td>
                                        <strong>
                                          {nomination.cargoHoseConnected && (
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.cargoHoseConnected} UTC`}</Moment>
                                          )}
                                        </strong>
                                      </td>
                                      <td>{"Cargo Hose Disconnected: "}</td>
                                      <td>
                                        <strong>
                                          {nomination.cargoHoseDisconnected && (
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.cargoHoseDisconnected} UTC`}</Moment>
                                          )}
                                        </strong>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>{"Transfer Start: "}</td>
                                      <td>
                                        <strong>
                                          {nomination.transferStart && (
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.transferStart} UTC`}</Moment>
                                          )}
                                        </strong>
                                      </td>

                                      <td>{"Transfer Finish: "}</td>
                                      <td>
                                        <strong>
                                          {
                                            <Moment
                                              format="ll HH:mm"
                                              local
                                            >{`${nomination.transferFinish} UTC`}</Moment>
                                          }
                                        </strong>
                                      </td>
                                    </tr>
                                    {nomination.transferType !==
                                      "OverTheSide" && (
                                      <tr>
                                        <td>{"Tank/Cargo Accepted: "}</td>
                                        <td>
                                          <strong>
                                            {nomination.tankOrCargoAccepted && (
                                              <Moment
                                                format="ll HH:mm"
                                                local
                                              >{`${nomination.tankOrCargoAccepted} UTC`}</Moment>
                                            )}
                                          </strong>
                                        </td>

                                        <td></td>
                                      </tr>
                                    )}
                                  </table>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      )
                    )}
                  </table>
                </div>
              )}
            </div>
          </tbody>

          <tfoot></tfoot>
        </table>
      )}

      {props.reportType == "Details" && (
        <table>
          <thead>
            <Stack tokens={{ childrenGap: 20 }} horizontal>
              <div
                style={{
                  borderRight: "0.5px solid #E2E6E8",
                  paddingRight: "20px",
                  marginBottom: "25px",
                }}
              >
                <img
                  src="/logo-yellow.svg"
                  style={{ width: 80.25, height: 48 }}
                />
              </div>
              <div
                style={{
                  paddingRight: "15px",
                  paddingLeft: "5px",
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Statement of Facts Summary Reports
                </div>
                <div>QADWorks Technical Solutions Inc</div>
              </div>
            </Stack>

            <div
              style={{
                backgroundColor: "black",
                height: "40px",
                paddingTop: "5px",
                paddingLeft: "15px",
                color: "white",
                marginBottom: "10px",
              }}
            >
              <table style={{ width: "100%", color: "white" }}>
                <tr>
                  <td style={{ width: "50%" }}>
                    <span
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {props.dailyReport.vehicleName}
                    </span>
                  </td>
                  <td style={{ width: "25%" }}>
                    Line Handling #:{" "}
                    <strong>
                      {`${props.dailyReport.lineHandlingNo.substr(
                        props.dailyReport.lineHandlingNo.length - 6
                      )}`}
                    </strong>
                  </td>

                  <td style={{ width: "25%" }}>
                    {" "}
                    Departed:{" "}
                    <strong>
                      {props.dailyReport.departureDate && (
                        <Moment
                          format="LL"
                          local
                        >{`${props.dailyReport.departureDate} UTC`}</Moment>
                      )}
                    </strong>
                  </td>
                </tr>
              </table>
            </div>
          </thead>

          <tbody>
            {detailsNominationCount > 0 && (
              <>
                {props.dailyReport.nominations.map((nomination) => (
                  <>
                    {nomination.isSelected && (
                      <table
                        className={
                          lastDetailsRecord.nominationNo ===
                          nomination.nominationNo
                            ? ""
                            : "pagebreak"
                        }
                      >
                        <tr>
                          <td>
                            <table className="tbl-report">
                              <tr className="report-header-gray">
                                <td>Description</td>
                                <td>Date</td>
                                <td>Time</td>
                                <td>Delay Reason</td>
                                <td>Delay Duration</td>
                                <td>Status</td>
                              </tr>

                              {props.dailyReport.lineHandlingActivities.map(
                                (activity) => (
                                  <tr>
                                    <td>{activity.description}</td>
                                    <td>
                                      {activity.executionDate && (
                                        <Moment format="ll" local>
                                          {`${activity.executionDate} UTC`}
                                        </Moment>
                                      )}
                                      {!activity.executionDate && "-"}
                                    </td>
                                    <td>
                                      {activity.executionDate && (
                                        <Moment format="HH:mm" local>
                                          {`${activity.executionDate} UTC`}
                                        </Moment>
                                      )}
                                      {!activity.executionDate && "-"}
                                    </td>
                                    <td>
                                      {activity.delayReason &&
                                        activity.delayReason}
                                      {!activity.delayReason && "-"}
                                    </td>
                                    <td>
                                      {activity.delayReason &&
                                        activity.delayDuration}
                                      {!activity.delayReason && "-"}
                                    </td>
                                    <td
                                      style={{
                                        color: `${
                                          activity.status === "Done"
                                            ? "#4CAF50"
                                            : ""
                                        }`,
                                      }}
                                    >
                                      {activity.status}
                                    </td>
                                  </tr>
                                )
                              )}
                            </table>
                            {props.includeComments &&
                              props.dailyReport.comments.length > 0 && (
                                <table
                                  style={{
                                    width: "100%",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <tr>
                                    <td>
                                      <div
                                        style={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                          paddingRight: "15px",
                                          margin: "10px 0",
                                          color: "#00447E",
                                        }}
                                      >
                                        Comments
                                      </div>
                                    </td>
                                  </tr>

                                  {props.dailyReport.comments.map((comment) => (
                                    <tr>
                                      <td>
                                        <div
                                          style={{
                                            border: "0.5px solid #E2E6E8",
                                            padding: "5px 5px 15px 5px",
                                          }}
                                        >
                                          <Stack
                                            tokens={{ childrenGap: 20 }}
                                            horizontal
                                          >
                                            <strong>
                                              {comment.submittedByName}{" "}
                                            </strong>
                                            <div style={{ color: "E2E6E8" }}>
                                              {"•"}&nbsp;&nbsp;
                                              <Moment
                                                format="ll HH:mm"
                                                local
                                              >{`${new Date(
                                                comment.submittedOn
                                              )} UTC`}</Moment>
                                            </div>
                                          </Stack>
                                          <div
                                            style={{
                                              whiteSpace: "pre-wrap",
                                            }}
                                          >
                                            {comment.commentText}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </table>
                              )}

                            <div
                              style={{
                                marginTop: "15px",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: "black",
                                  height: "40px",
                                  paddingTop: "5px",
                                  paddingLeft: "15px",
                                  color: "white",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {`Nomination# ${nomination.nominationNo.substr(
                                    nomination.nominationNo.length - 6
                                  )}`}
                                </span>
                              </div>

                              <div style={{ border: "0.5px solid #E2E6E8" }}>
                                <table className="tbl-report-border">
                                  <tr>
                                    <td>Surveyor:</td>
                                    <td>
                                      <strong>{nomination.surveyor}</strong>
                                    </td>
                                    <td>Dock:</td>
                                    <td>
                                      <strong>{nomination.dock}</strong>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Customer:</td>
                                    <td>
                                      <strong>{nomination.customer}</strong>
                                    </td>
                                    <td>Jettyline:</td>
                                    <td>
                                      <strong>{nomination.jettyLine}</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Product:</td>
                                    <td>
                                      <strong>{nomination.product}</strong>
                                    </td>
                                    <td>Vapor Line:</td>
                                    <td>
                                      <strong>{nomination.vaporLine}</strong>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Quantity:</td>
                                    <td>
                                      <strong>{nomination.quantity}</strong>
                                    </td>
                                    <td>Ship Line:</td>
                                    <td>
                                      <strong>{nomination.shipLine}</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Tank:</td>
                                    <td>
                                      <strong>{nomination.tank}</strong>
                                    </td>
                                    <td>Ship Vapor Line:</td>
                                    <td>
                                      <strong>
                                        {nomination.shipVaporLine}
                                      </strong>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Direction:</td>
                                    <td>
                                      <strong>
                                        {nomination.nominationType}
                                      </strong>
                                    </td>
                                    <td>Stowage:</td>
                                    <td>
                                      <strong>{nomination.stowage}</strong>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Samples Count:</td>
                                    <td>
                                      <strong>
                                        {nomination.samplingCount}
                                      </strong>
                                    </td>
                                    <td></td>
                                    <td>
                                      <strong></strong>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>

                            <table
                              className="tbl-report"
                              style={{
                                marginTop: "15px",
                              }}
                            >
                              <tr className="report-header-gray">
                                <td>Description</td>
                                <td>Date</td>
                                <td>Time</td>
                                <td>Delay Reason</td>
                                <td>Delay Duration</td>
                                <td>Status</td>
                              </tr>

                              {nomination.nominationActivities.map(
                                (activity) => (
                                  <tr>
                                    <td>{activity.description}</td>
                                    <td>
                                      {activity.executionDate && (
                                        <Moment format="ll" local>
                                          {`${activity.executionDate} UTC`}
                                        </Moment>
                                      )}
                                      {!activity.executionDate && "-"}
                                    </td>
                                    <td>
                                      {activity.executionDate && (
                                        <Moment format="HH:mm" local>
                                          {`${activity.executionDate} UTC`}
                                        </Moment>
                                      )}
                                      {!activity.executionDate && "-"}
                                    </td>
                                    <td>
                                      {activity.delayReason &&
                                        activity.delayReason}
                                      {!activity.delayReason && "-"}
                                    </td>
                                    <td>
                                      {activity.delayReason &&
                                        activity.delayDuration}
                                      {!activity.delayReason && "-"}
                                    </td>
                                    <td
                                      style={{
                                        color: `${
                                          activity.status === "Done"
                                            ? "#4CAF50"
                                            : ""
                                        }`,
                                      }}
                                    >
                                      {activity.status}
                                    </td>
                                  </tr>
                                )
                              )}
                            </table>

                            {props.includeComments &&
                              nomination.comments.length > 0 && (
                                <table
                                  style={{
                                    width: "100%",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <tr>
                                    <td>
                                      <div
                                        style={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                          paddingRight: "15px",
                                          margin: "10px 0",
                                          color: "#00447E",
                                        }}
                                      >
                                        Comments
                                      </div>
                                    </td>
                                  </tr>

                                  {nomination.comments.map((comment) => (
                                    <tr>
                                      <td>
                                        <div
                                          style={{
                                            border: "0.5px solid #E2E6E8",
                                            padding: "5px 5px 15px 5px",
                                          }}
                                        >
                                          <Stack
                                            tokens={{ childrenGap: 20 }}
                                            horizontal
                                          >
                                            <strong>
                                              {comment.submittedByName}{" "}
                                            </strong>
                                            <div style={{ color: "E2E6E8" }}>
                                              {"•"}&nbsp;&nbsp;
                                              <Moment
                                                format="ll HH:mm"
                                                local
                                              >{`${new Date(
                                                comment.submittedOn
                                              )} UTC`}</Moment>
                                            </div>
                                          </Stack>
                                          <div
                                            style={{
                                              whiteSpace: "pre-wrap",
                                            }}
                                          >
                                            {comment.commentText}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </table>
                              )}
                            {lastDetailsRecord.nominationNo ==
                              nomination.nominationNo && (
                              <>
                                <br />
                                <table>
                                  <tr>
                                    <td>
                                      <table className="tbl-report">
                                        <tr className="report-header-gray">
                                          <td></td>
                                          <td>VESSEL REPRESENTATIVE</td>
                                          <td>QADWORKS REPRESENTATIVE</td>
                                          <td>QADWORKS REPRESENTATIVE</td>
                                          <td>QADWORKS REPRESENTATIVE</td>
                                        </tr>

                                        <tr>
                                          <td>SIGNATURE</td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>PRINT NAME</td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td>POSITION TIME/DATE</td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </>
                            )}
                          </td>
                        </tr>
                      </table>
                    )}
                  </>
                ))}
              </>
            )}
            {detailsNominationCount === 0 && (
              <div>
                <table className="tbl-report">
                  <tr className="report-header-gray">
                    <td>Description</td>
                    <td>Date</td>
                    <td>Time</td>
                    <td>Delay Reason</td>
                    <td>Delay Duration</td>
                    <td>Status</td>
                  </tr>

                  {props.dailyReport.lineHandlingActivities.map((activity) => (
                    <tr>
                      <td>{activity.description}</td>
                      <td>
                        {activity.executionDate && (
                          <Moment format="ll" local>
                            {`${activity.executionDate} UTC`}
                          </Moment>
                        )}
                        {!activity.executionDate && "-"}
                      </td>
                      <td>
                        {activity.executionDate && (
                          <Moment format="HH:mm" local>
                            {`${activity.executionDate} UTC`}
                          </Moment>
                        )}
                        {!activity.executionDate && "-"}
                      </td>
                      <td>
                        {activity.delayReason && activity.delayReason}
                        {!activity.delayReason && "-"}
                      </td>
                      <td>
                        {activity.delayReason && activity.delayDuration}
                        {!activity.delayReason && "-"}
                      </td>
                      <td
                        style={{
                          color: `${
                            activity.status === "Done" ? "#4CAF50" : ""
                          }`,
                        }}
                      >
                        {activity.status}
                      </td>
                    </tr>
                  ))}
                </table>
                {props.includeComments &&
                  props.dailyReport.comments.length > 0 && (
                    <table
                      style={{
                        width: "100%",
                        tableLayout: "fixed",
                      }}
                    >
                      <tr>
                        <td>
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              paddingRight: "15px",
                              margin: "10px 0",
                              color: "#00447E",
                            }}
                          >
                            Comments
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {props.dailyReport.comments.map((comment) => (
                            <div
                              style={{
                                border: "0.5px solid #E2E6E8",
                                padding: "5px 5px 15px 5px",
                              }}
                            >
                              <Stack tokens={{ childrenGap: 20 }} horizontal>
                                <strong>{comment.submittedByName} </strong>
                                <div style={{ color: "E2E6E8" }}>
                                  {"•"}&nbsp;&nbsp;
                                  <Moment format="ll HH:mm" local>{`${new Date(
                                    comment.submittedOn
                                  )} UTC`}</Moment>
                                </div>
                              </Stack>
                              <div
                                style={{
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {comment.commentText}
                              </div>
                            </div>
                          ))}
                        </td>
                      </tr>
                    </table>
                  )}
                <br />
                <table className="tbl-report">
                  <tr className="report-header-gray">
                    <td></td>
                    <td>VESSEL REPRESENTATIVE</td>
                    <td>QADWORKS REPRESENTATIVE</td>
                    <td>QADWORKS REPRESENTATIVE</td>
                    <td>QADWORKS REPRESENTATIVE</td>
                  </tr>

                  <tr>
                    <td>SIGNATURE</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>PRINT NAME</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>POSITION TIME/DATE</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
              </div>
            )}
          </tbody>

          <tfoot></tfoot>
        </table>
      )}
    </>
  );
};

export default PrintPage;
